import { Plugins, NetworkStatus, KeyboardInfo, AppState } from '@capacitor/core';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

const { Device } = Plugins;

export async function isMobile(): Promise<boolean> {
  const info = await Device.getInfo();
  switch (info.platform) {
    case 'ios':
      return true;

    case 'android':
      return true;

    case 'web':
      return false;
    case 'electron':
      return false;

    default:
      break;
  }
  return false;
}

export async function lockPortrait() {
  if (await isMobile()) {
    ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
  }
}

export async function unlockPortrait() {
  if (await isMobile()) {
    ScreenOrientation.unlock();
  }
}

export async function scanQR(options?: phonegapBarcode.BarcodeScanOptions): Promise<phonegapBarcode.BarcodeScanResult> {
  return new Promise((resolve, reject) => {
    (window.cordova.plugins as CordovaPlugins).barcodeScanner.scan(
      result => {
        resolve(result);
      },
      err => {
        reject(err);
      },
      options
    );
  });
}

export async function addNetworkListeners(networkStatusChange: (status: NetworkStatus) => void) {
  if (await isMobile()) {
    Plugins.Network.addListener('networkStatusChange', networkStatusChange);
  }
}

export async function addKeyboardListeners(onKeyboardDidShow: (info: KeyboardInfo) => void, onKeyboardDidHide: () => void) {
  if (await isMobile()) {
    Plugins.Keyboard.addListener('keyboardDidShow', onKeyboardDidShow);
    Plugins.Keyboard.addListener('keyboardDidHide', onKeyboardDidHide);
  }
}

let timeWentInactive = 0;
export async function addAppListenerToCheckIfActive(logout: () => void) {
  if (await isMobile()) {
    Plugins.App.addListener('appStateChange', (state: AppState) => {
      if (!state.isActive) {
        timeWentInactive = new Date().getTime();

        setTimeout(() => {
          Plugins.App.getState().then(currentState => {
            if (!currentState.isActive) {
              logout();
            }
          });
        }, 15000);
      } else if (new Date().getTime() - timeWentInactive > 10000) {
        logout();
      }
    });
  }
}
